// extracted by mini-css-extract-plugin
export const root = "quote-module--root--2rS6K";
export const quote = "quote-module--quote--3uYrB";